import * as React from 'react'

import { Box, Card, Checkbox, Grid, Title } from '@factorialco/deprecated-design-system'
import { Form as FactorialForm } from 'factorial-form'

import { observer } from 'mobx-react'

import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import type Job from 'modules/ats/store/models/Job'
import type { IJob } from 'modules/ats/store/models/Job'

class JobForm extends FactorialForm {
  constructor(values: IJob) {
    super(values, {
      allow_internal_apply: 'boolean',
      allow_referral: 'boolean',
    })
  }
}

interface Props {
  job: Job
}

export const OpenPositions = observer(({ job }: Props) => {
  const form: JobForm = useLazyRef(() => new JobForm(job.toJS())).current

  const onSubmit = (field: string, value: boolean) => {
    form.get(field).set(value)
    return asyncAction(() => form.save(job))
  }

  return (
    <Box gap="s24">
      <Title
        title={i18n.t('ats.job_details.promotion.open_positions.title')}
        description={i18n.t('ats.job_details.promotion.open_positions.description')}
        variant="500"
        illustration="diamond"
      />
      <Grid variant="large">
        <Card>
          <Card.Title
            size="small"
            action={
              <Checkbox
                checked={form.get('allow_referral').value}
                onChange={(event) => onSubmit('allow_referral', event.target.checked)}
                ariaLabel={i18n.t('ats.job_details.promotion.open_positions.allow_referral_check')}
              />
            }
          >
            {i18n.t('ats.job_details.promotion.open_positions.allow_referral_label')}
          </Card.Title>
          <Card.Description>
            {i18n.t('ats.job_details.promotion.open_positions.allow_referral_description')}
          </Card.Description>
        </Card>
        <Card>
          <Card.Title
            size="small"
            action={
              <Checkbox
                checked={form.get('allow_internal_apply').value}
                onChange={(event) => onSubmit('allow_internal_apply', event.target.checked)}
                ariaLabel={i18n.t(
                  'ats.job_details.promotion.open_positions.allow_internal_apply_check'
                )}
              />
            }
          >
            {i18n.t('ats.job_details.promotion.open_positions.allow_internal_apply_label')}
          </Card.Title>
          <Card.Description>
            {i18n.t('ats.job_details.promotion.open_positions.allow_internal_apply_description')}
          </Card.Description>
        </Card>
      </Grid>
    </Box>
  )
})
